import { Col } from "react-bootstrap";
import { ArrowLeft } from "react-feather";
import { useNavigate } from "react-router-dom";

export const HeaderTitle = (props) => {
  const navigate = useNavigate();
  return (
    <Col className="header-title d-flex align-items-center justify-content-start">
      <ArrowLeft
        size={25}
        style={{ marginRight: "15px" }}
        onClick={() => navigate(-1)}
      />
      <h4
        style={{
          marginTop: "8px",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {props?.title}
      </h4>
    </Col>
  );
};
